import { MenuItem, Typography } from '@mui/material';
import type { ContractStatus } from '@weft/types';
import { useUpdateContractStatus } from 'apps/app/src/hooks/requests/use-update-contract-status';
import { runMutation } from 'apps/app/src/utils/vy-mutation';
import React from 'react';

type UpdateContractStatusMenuItemProps = { 
  isActive: boolean;
  disabled?: boolean;
  onClick: () => void;
  contractId: string;
};

export function UpdateContractStatusMenuItem({ isActive, contractId, onClick, disabled }: UpdateContractStatusMenuItemProps) {
  const updateContractStatusMutation = useUpdateContractStatus(contractId);
  
  async function handleItemClick() {
    const status: ContractStatus = isActive ? 'Inactive' : 'Active';

    await runMutation(
      updateContractStatusMutation,
      { status },
      {
        pending: `Updating contract status to ${status}...`,
        success: `Contract status updated to ${status}`,
        error: `Failed to update contract status to ${status}`,
      },
    );
    
    onClick();
  }

  return (
    <>
      <MenuItem
        disabled={disabled}
        onClick={handleItemClick}
      >
        <Typography>{isActive ? 'Deactivate' : 'Activate'}</Typography>
      </MenuItem>
    </>
  );
}
